import React from "react";
import { Grid, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import { useTranslation } from "react-i18next";

const ProfileView = (props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color="textPrimary" variant="h5">
          {t("register.profile_title")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("register.first_name")}
          name="first_name"
        />
      </Grid>
      <Grid item xs={12}>
        <EditText {...props} label={t("register.last_name")} name="last_name" />
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("register.email")}
          name="email"
          type="email"
        />
      </Grid>
    </Grid>
  );
};

export default ProfileView;
